export default __webpack_public_path__ + "img/d9dee893b361e49dfc6546e8aa842b97.svg";